import React from 'react';

import { withEventScope } from '@repo/event-processor';

import DesktopHeader from 'components/HeadMenu/DesktopHeader/DesktopHeader';
import MobileHeader from 'components/HeadMenu/MobileHeader/MobileHeader';

import { DesktopHeaderWrapper, MobileHeaderWrapper } from './styles';
import { HeaderProps } from './types';

/**
 * The Header is a Menu on the top of the page.
 */
const Header: React.FC<HeaderProps> = (props) => {
  return (
    <>
      <DesktopHeaderWrapper>
        <DesktopHeader {...props} />
      </DesktopHeaderWrapper>
      <MobileHeaderWrapper>
        <MobileHeader {...props} />
      </MobileHeaderWrapper>
    </>
  );
};

export default withEventScope(Header, { feature: 'headMenu' });
